import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Context } from '../contexts/AuthContext';
import { useAuthData } from '../contexts/AuthDataContext';

const ProtectedRoute = ({ children, allowWithoutOrg = false, contractorAllowed = false }) => {
  const { user, loading } = useContext(Context);
  const { userData, loading: authDataLoading } = useAuthData();
  const location = useLocation();
  
  console.log("🔒 ProtectedRoute - user:", user, "loading:", loading);

  // Still loading auth state
  if (loading || authDataLoading) return <div>Loading...</div>;
  
  // Not logged in - redirect to login
  if (!user) return <Navigate to="/login" replace />;

  // Check if user has an organization (or is super admin)
  const hasOrg = userData?.organisation_id || userData?.isSuperAdmin;
  
  // If route doesn't allow users without org, and user has no org, redirect to onboarding
  if (!allowWithoutOrg && !hasOrg && userData) {
    // Don't redirect if already on onboarding page
    if (location.pathname !== '/onboarding') {
      console.log("🔄 Redirecting to onboarding - user has no organization");
      return <Navigate to="/onboarding" replace />;
    }
  }

  // Contractor role: web app is scoped to the tasks page (mobile is the
  // primary surface for vendor crew; see VENDOR_MANAGEMENT_PLAN.md 3.4).
  const role = userData?.role_name?.toLowerCase();
  if (role === 'contractor' && !contractorAllowed) {
    return <Navigate to="/taskmanagement" replace />;
  }

  return children;
};

export default ProtectedRoute;

